module.exports = __webpack_public_path__ + "static/media/SliderImg2.b19a249d.png";